/**
 * crop-checkerboard.ts — Asigna un patrón visual de borde (color + dash) a
 * cada cultivo distinto entre los módulos visibles del mapa, para que dos
 * módulos no contiguos con el mismo cultivo se reconozcan de un vistazo sin
 * confundirse con el color de RELLENO (que ya lo ocupa el status operativo
 * o el NDVI — ver STATUS_COLORS en components/shared/MapView.tsx).
 */

export interface CropPattern {
  colorHex: string;
  dashArray: string;
}

/** Ciclo de patrones de trazo — se combinan con el color propio del cultivo. */
const DASH_PATTERNS = ['', '6 4', '2 4', '10 4 2 4', '1 4'];

export function buildCropPatternMap(
  crops: { cropId: string; colorHex: string }[],
): Record<string, CropPattern> {
  const map: Record<string, CropPattern> = {};
  crops.forEach((crop, i) => {
    map[crop.cropId] = {
      colorHex: crop.colorHex,
      dashArray: DASH_PATTERNS[i % DASH_PATTERNS.length],
    };
  });
  return map;
}

/** Trazo de una zona/lote cuyo último ciclo está cerrado (D16): punteado fino, distinto de DASH_PATTERNS. */
export const CLOSED_CYCLE_DASH = '1 6';
